import { LevelType, SizingItemsType } from 'data/types';
import { getVisibleSizingDefaultsCategories } from 'utils/structure-sizing-presence';

export type FineTuningComparableItem = {
  defaultsKey: keyof SizingItemsType;
  fields: string[];
};

export function getVisibleFineTuningComparableItems(
  structure: LevelType[]
): FineTuningComparableItem[] {
  return getVisibleSizingDefaultsCategories(structure).flatMap((category) =>
    category.items.map((item) => ({
      defaultsKey: item.defaultsKey as keyof SizingItemsType,
      fields: item.fields.map((field) => field.key)
    }))
  );
}

export function fieldValuesDiffer(current: unknown, recommended: unknown) {
  if (current === recommended) {
    return false;
  }

  if (current == null && recommended == null) {
    return false;
  }

  if (typeof current === 'number' && typeof recommended === 'string') {
    return String(current) !== recommended;
  }

  if (typeof current === 'string' && typeof recommended === 'number') {
    return current !== String(recommended);
  }

  return current !== recommended;
}

export function fineTuningValuesDifferFromRecommended(
  current: SizingItemsType,
  recommended: SizingItemsType,
  items: FineTuningComparableItem[]
) {
  return items.some((item) => {
    const currentValues = current[item.defaultsKey] as
      | Record<string, unknown>
      | undefined;
    const recommendedValues = recommended[item.defaultsKey] as
      | Record<string, unknown>
      | undefined;

    if (!currentValues || !recommendedValues) {
      return currentValues !== recommendedValues;
    }

    return item.fields.some((field) =>
      fieldValuesDiffer(currentValues[field], recommendedValues[field])
    );
  });
}

export function insulationRowsDifferFromRecommended(
  rows: ReadonlyArray<{
    value: string | number;
    suggestedLevel?: number;
  }>
) {
  return rows.some(
    (row) => row.suggestedLevel != null && row.value !== row.suggestedLevel
  );
}
